(function(){
    'use strict'

    angular
    .module('app.cupones')
    .controller('cupones.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();

        const MONEDA_COLONES = 1;
        const MONEDA_DOLARES = 2;

        var permisosCupones = UserInfoService.getPermisosCupones();

        var vm = this;

        vm.uiData = {
            puedeGuardar: permisosCupones.guardar === true,
            puedeModificar: permisosCupones.modificar === true,
            puedeEliminar: permisosCupones.eliminar === true,
            esOrganizador: UserInfoService.esOrganizador()
        };

        vm.criteriosBusqueda = {
            eventoId: 0,
        };

        vm.collection = [];
        vm.eventos = [];
        vm.title = 'Cupones';

        getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        vm.goToEdit = function(data){
            
            var path = '/editar-cupon/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.goToInscripcion = function(data){
            
            var path = '/crear-inscripcion/' + data.id;

            $location.path(path);
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.getMonedaSymbol = function(monedaId)
        {
            switch (monedaId) {
                case MONEDA_COLONES:
                    return '₡';
                case MONEDA_DOLARES:
                    return '$';
                default:
                    return '';
            }
        }

        function getRemoteController()
        {
            if(UserInfoService.esOrganizador())
            {
                return 'api/Cupones/All';
            }

            return 'api/Cupones/Usuario';
        }

        vm.clearCriteria = function()
        {
            vm.criteriosBusqueda = {
                eventoId: 0,
            };
        };

        getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function getAll(){
            ApiBaseService.remoteController = getRemoteController();

            const criterios = [
                vm.criteriosBusqueda.eventoId,
            ];

            var promise = ApiBaseService.getAll(criterios);

            promise
            .then(function(collection){
                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Cupones';
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();